import axios from 'axios';
import { useEffect, useState } from 'react';


export function useProcessId(): string | undefined {
  const [processId, setProcessId] = useState<string | undefined>(undefined);
  useEffect(() => {
    const processIdFromSession = sessionStorage.getItem('registrationProcessUid');
    if (process.env.PUBLIC_URL === '/rejestracja' && processIdFromSession == null) {
      axios.get('/api/status')
           .then(() => axios.post('/api/process/registration/public')
                            .then(response => {
                              const newProcessId = response.data;
                              sessionStorage.setItem('registrationProcessUid', newProcessId);
                              sessionStorage.setItem('leadId', newProcessId);
                              setProcessId(newProcessId);
                            }));
    } else {
      setProcessId(processIdFromSession!);
    }
  }, []);
  return processId;
}

function isLeadIdFormat(str: string) {
  return /^[0-9a-zA-Z]{5}-[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(str);
}

export function appendExternalLeadId(externalLeadId: string): void {
  if (!isLeadIdFormat(externalLeadId)) {
    return;
  }
  const leadId = sessionStorage.getItem('leadId');
  if (!leadId) {
    throw new Error('Lead id is missing');
  }
  if (leadId.startsWith('EXT')) {
    return;
  }
  sessionStorage.setItem('leadId', `EXT:${externalLeadId}:${leadId}`);
}

interface InitProcessResponse {
  processId: string,
  leadId: string
}

